import { render, staticRenderFns } from "./mb-main.vue?vue&type=template&id=9d2ef19e&"
import script from "./mb-main.vue?vue&type=script&lang=js&"
export * from "./mb-main.vue?vue&type=script&lang=js&"
import style0 from "./mb-main.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports